// @flow

import * as React from 'react';

import clsx from 'clsx';

import { Base } from '@gandi/ui';

import styles from './ResponsiveTitleCell.scss';

export type Props = {
  children: React.Node,
  className?: string,
  ...
};

function TitleCell({ children, className, ...extraProps }: Props) {
  return (
    // $FlowFixMe[cannot-spread-inexact]
    <Base
      flex
      flexGrow1
      flexAlignItemsCenter
      className={clsx(styles.root, className)}
      {...extraProps}
    >
      <Base tagName="h3" margin="none" className={styles.title}>
        {children}
      </Base>
    </Base>
  );
}

export default (React.memo<Props>(TitleCell): React.ComponentType<Props>);
